import React from 'react';

import Icon, { IconProps } from '../../icon';
import useStyles from './styles';

export const User = (): string => {
  const classes = useStyles();
  return classes.user;
};

export const UserIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.user} {...props} />;
};

export const UserPlus = (): string => {
  const classes = useStyles();
  return classes.userPlus;
};

export const UserPlusIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.userPlus} {...props} />;
};

export const UserMinus = (): string => {
  const classes = useStyles();
  return classes.userMinus;
};

export const UserMinusIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.userMinus} {...props} />;
};

export const UserRemove = (): string => {
  const classes = useStyles();
  return classes.userRemove;
};

export const UserRemoveIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.userRemove} {...props} />;
};
